import React from 'react';
import { formatCurrency } from './formatters';
import './RiskBreakdown.css';

/**
 * CalculationDetails — collapsed section with derived defaults, diagnostics,
 * weighted EBITDA/SDE, and engine version.
 *
 * Props:
 *   derivedDefaults {Array} — result.derivedDefaults
 *   diagnostics {Array<string>} — result.diagnostics
 *   engineVersion {string} — result.engineVersion
 *   weightedEBITDA {number} — result.weightedEBITDA
 *   weightedSDE {number} — result.weightedSDE
 */
function CalculationDetails({
  derivedDefaults = [],
  diagnostics = [],
  engineVersion = '',
  weightedEBITDA,
  weightedSDE,
}) {
  function humanizeDiagnostic(code) {
    return code.replace(/_/g, ' ');
  }

  return (
    <section className="calc-details-section">
      <details className="calc-details-container">
        <summary className="calc-details-summary">Calculation details</summary>

        <div className="calc-details-body">
          {/* Weighted EBITDA / SDE chips */}
          <div className="calc-details-chips">
            <span className="calc-details-chip">
              <span className="calc-details-chip-label">Weighted EBITDA</span>
              <span className="calc-details-chip-value">
                {formatCurrency(weightedEBITDA)}
              </span>
            </span>
            <span className="calc-details-chip">
              <span className="calc-details-chip-label">Weighted SDE</span>
              <span className="calc-details-chip-value">
                {formatCurrency(weightedSDE)}
              </span>
            </span>
          </div>

          {/* Derived defaults */}
          {derivedDefaults.length > 0 && (
            <div>
              <p className="calc-details-derived-heading">
                Values we filled in for you
              </p>
              <ul className="calc-details-derived-list">
                {derivedDefaults.map((d, idx) => (
                  <li key={idx} className="calc-details-derived-item">
                    <strong>{d.field}</strong> → {d.value}
                    {d.source && (
                      <span className="calc-details-derived-source">
                        ({d.source})
                      </span>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          )}

          {/* Diagnostics */}
          {diagnostics.length > 0 && (
            <div>
              <p className="calc-details-diag-heading">Diagnostics</p>
              <ul className="calc-details-diag-list">
                {diagnostics.map((code, idx) => (
                  <li key={idx} className="calc-details-diag-item">
                    {humanizeDiagnostic(code)}
                  </li>
                ))}
              </ul>
            </div>
          )}

          {/* Engine version */}
          <p className="calc-details-engine">Engine {engineVersion}</p>
        </div>
      </details>
    </section>
  );
}

export default CalculationDetails;
